import {Component, Input} from '@angular/core';

@Component({
    selector: 'large-page-layout',
    templateUrl: './large-page-layout.component.html'
})
export class LargePageLayoutWidget {
    @Input() title: string;
    @Input() goBackLink: string;
    @Input() icon: string;
}
